import React, { Component } from 'react';
import { Image, Grid, Row, Col } from 'react-bootstrap';
import logo from './logo.png';
import './home.css';

export default class Home extends Component {
    render() {
        return (
            <div className="Aligner">
                <div className="Aligner-item">
                    <Image responsive src={logo} />  
                <Grid fluid className="contacts">
                    <Row>
                        <Col sm={12} md={4}>
                        <a href="https://www.instagram.com/afcmuswellhill" target="_blank" rel="noopener noreferrer"><span><i className="fab fa-instagram"></i> afcmuswellhill</span></a>
                        </Col>
                        <Col sm={12} md={4}>
                        <a href="https://www.twitter.com/afcmuswellhill" target="_blank" rel="noopener noreferrer"><span><i className="fab fa-twitter"></i> afcmuswellhill</span></a>
                        </Col>
                        <Col sm={12} md={4}>
                        <a href="mailto:hello@afcmuswellhill.com"><span><i className="far fa-envelope"></i> hello@afcmuswellhill.com</span></a>
                        </Col>
                    </Row>
                </Grid>
            </div>
            </div>
        );    
    }
}


// WEBPACK FOOTER //
// ./src/home/index.js